var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test pad"},[_c('button',{staticClass:"button",class:{ 'is-loading': _vm.loading },on:{"click":function($event){return _vm.go()}}},[_vm._v("Go")])])}
var staticRenderFns = []

export { render, staticRenderFns }